import React from 'react';

import { CreateOrg } from 'presentation/pages';

export const MakeCreateOrgFactory: React.FC = () => {
  return <CreateOrg />;
};
